export default {
	login: "Login",
	email: "Email",
	password: "Password",
	username: "Username",
	inviteCode: "Invite Code",
	forgotPassword: "Forgot my password",
	resetPassword: "Reset password",
	welcomeBack: "Welcome back",
	loginSubtitle: "Sign in to your account to continue",
	createAccount: "Create new account",
	registerSubtitle: "Join the ORI system",
	createAccountButton: "Create account",
	noAccount: "Don't have an account? Sign up",
	hasAccount: "Already have an account? Sign in",
	haveInviteCode: "Have an invite code? Activate it here",
	systemDescription: "Manage your temple with respect to traditions and modern technology",
	welcomeToOri: "Welcome to ORI",
	registerDescription: "Start your journey in spiritual management with the best system for temples",
	features: {
		people: "People Management",
		peopleDesc: "Registration, attendance and tracking",
		journey: "Spiritual Journey",
		journeyDesc: "Guides, orixás and development stages",
		rituals: "Rituals & Sessions",
		ritualsDesc: "Schedule, types and attendance control",
		financial: "Financial Control",
		financialDesc: "Funds, subscriptions, payments and reports",
		communication: "Communication",
		communicationDesc: "Messages, TV and support",
		reports: "Dashboard & Reports",
		reportsDesc: "Dashboard and overview",
	},
	messages: {
		registerSuccess: "User registered successfully! Redirecting to login...",
		loginError: "Login error",
		registerError: "Error registering user",
	},
	backToLogin: "Back to login",
	checkYourEmail: "Check your inbox and follow the instructions to reset your password.",
	confirmPassword: "Confirm Password",
	emailSent: "Email sent!",
	forgotPasswordSubtitle: "Enter your email to receive a recovery link",
	invalidToken: "Invalid link",
	invalidTokenMessage: "This link has expired or is invalid. Please request a new recovery link.",
	newPassword: "New Password",
	passwordChanged: "Password changed!",
	passwordChangedMessage: "Your password has been changed successfully. Log in to continue.",
	passwordsDoNotMatch: "Passwords do not match",
	requestNewLink: "Request new link",
	resetError: "Error resetting password. Please try again.",
	resetPasswordSubtitle: "Enter your new password",
	sendResetLink: "Send recovery link",
};
